import { SyntheticEvent, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useCustomerLogoUrls } from '../hooks'
import { updateUrl } from '../utils'
import { Col, Row } from './flex'
import { Input } from './input'
import CustomerLogo from './customer-logo'

export const TRACKING_ID_INPUT = 'TRACKING_ID_INPUT'
interface FormValues {
    TRACKING_ID_INPUT: string
}

interface SearchFormProps {
    onSearch: (trackingId: string, submitCount: number) => void
    trackingId?: string
    customer?: string
    error: boolean
    errorMessage: string
    isLoading: boolean
}

export const SearchForm = ({
    onSearch,
    trackingId,
    customer,
    error,
    errorMessage,
    isLoading,
}: SearchFormProps) => {
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors, submitCount },
    } = useForm({ defaultValues: { TRACKING_ID_INPUT: trackingId } })

    useEffect(() => {
        if (error) {
            setError(TRACKING_ID_INPUT, {
                type: 'manual',
                message: errorMessage,
            })
        }
    }, [error, errorMessage, setError])

    const onSubmit = async (data: FormValues) => {
        const newTrackingId = data[TRACKING_ID_INPUT]
        onSearch(newTrackingId, submitCount)
        updateUrl(customer ?? '', newTrackingId)
    }

    return (
        <div className="px-4 sm:px-12 py-4 sm:py-7 border rounded shadow-md mt-8 sm:-mt-16 lg:-mt-20 bg-white">
            <Row className="justify-between items-center mb-4">
                <h1 className="text-2xl sm:text-3xl text-primary-800">
                    Track my parcel
                </h1>
                {customer && (
                    <Col className="h-12 sm:h14 items-end">
                        <CustomerLogo customer={customer} />
                    </Col>
                )}
            </Row>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Row className="items-center">
                    <Input
                        name={TRACKING_ID_INPUT}
                        label="Your tracking ID"
                        register={register}
                        required="Please enter tracking ID"
                        error={errors[TRACKING_ID_INPUT]}
                        className="w-full"
                    />
                    <button
                        className={`w-12 h-12 ${
                            isLoading ? 'bg-blue-800' : 'bg-blue-500'
                        } hover:bg-blue-800 mt-2`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-10 w-10 text-gray-100 pl-1"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 5l7 7-7 7"
                            />
                        </svg>
                    </button>
                </Row>
            </form>
        </div>
    )
}
